// Membership card status code, using the value of dhl_code that return from CRM API
export const MembershipCardStatusCode = Object.freeze({
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  QUEUED: 'QUEUED',
});

export default MembershipCardStatusCode;
